import{createContext as o,useContext as r}from"react";const e=o({checked:void 0,onChange:void 0}),n=e.Provider;function t(){return r(e)}export{n as RowSelectionContextProvider,t as useRowSelection};
